<template>
  <div>
    <hr />

    <!-- Barra de acciones -->
    <div class="row g-2 align-items-end mb-3">
      <!-- Descripción -->
      <div class="col-auto">
        <label class="form-label mb-1 small fw-bold">Descripción</label>
        <input
          type="text"
          class="form-control form-control-sm"
          v-model="descripcionBusqueda"
          @keyup.enter="getDataNombre"
          placeholder="Buscar descripción..."
          style="width:260px; text-transform:uppercase"
        />
      </div>

      <!-- Tipo -->
      <div class="col-auto">
        <label class="form-label mb-1 small fw-bold">Tipo</label>
        <select
          class="form-select form-select-sm"
          v-model="tipoBusqueda"
          @change="getDataEstado"
          style="width:240px"
        >
          <option value="">-- Todos --</option>
          <option value="ESTADO">ESTADO</option>
          <option value="SUPERVISION">SUPERVISIÓN</option>
          <option value="AUDITORIA MEDICA">AUDITORÍA MÉDICA</option>
          <option value="AUDITORIA MEDICA FINALIZADA">AUDITORÍA MÉDICA FINALIZADA</option>
        </select>
      </div>

      <!-- Botón todos -->
      <div class="col-auto">
        <button
          type="button"
          class="btn btn-outline-secondary btn-sm d-flex align-items-center gap-1"
          @click="getDataPaginaTodos"
          title="Recargar todos los registros"
        >
          <span class="material-icons" style="font-size:16px">refresh</span> Todos
        </button>
      </div>

      <!-- Botón PDF -->
      <div class="col-auto">
        <button
          type="button"
          class="btn btn-outline-danger btn-sm d-flex align-items-center gap-1"
          @click="bitacoraTramitePDF"
          title="Generar PDF"
        >
          <span class="material-symbols-outlined" style="font-size:16px">picture_as_pdf</span>
          PDF
        </button>
      </div>

      <!-- Selector registros por página -->
      <div class="col-auto ms-auto d-flex align-items-center gap-2">
        <label class="form-label mb-0 small fw-bold">Mostrar</label>
        <select
          v-model.number="elementosPorPagina"
          class="form-select form-select-sm"
          style="width:75px"
          @change="aplicarPaginacion(1)"
        >
          <option :value="10">10</option>
          <option :value="25">25</option>
          <option :value="50">50</option>
          <option :value="100">100</option>
        </select>
        <span class="small text-muted">registros</span>
      </div>
    </div>

    <!-- Sin resultados -->
    <div v-if="bitacoratras.length === 0" class="alert alert-warning small" role="alert">
      No se encontraron registros.
    </div>

    <!-- Tabla -->
    <div class="table-responsive" v-if="bitacoratras.length > 0">
      <table class="table table-hover table-bordered table-sm" id="sampleTable">
        <thead class="table-dark">
          <!-- Encabezados con ordenamiento -->
          <tr>
            <th style="width:44px"></th>
            <th class="th-sort" @click="ordenarPor('fechaReg')">
              Fecha de registro <span>{{ iconOrden('fechaReg') }}</span>
            </th>
            <th class="th-sort" @click="ordenarPor('tipo')">
              Tipo <span>{{ iconOrden('tipo') }}</span>
            </th>
            <th class="th-sort" @click="ordenarPor('observacion')">
              Observación <span>{{ iconOrden('observacion') }}</span>
            </th>
            <th class="th-sort" @click="ordenarPor('usuarioNombre')">
              Usuario <span>{{ iconOrden('usuarioNombre') }}</span>
            </th>
          </tr>
          <!-- Filtros de columna -->
          <tr>
            <th></th>
            <th></th>
            <th>
              <select
                v-model="filtroTipo"
                @change="aplicarPaginacion(1)"
                class="form-select form-select-sm"
              >
                <option value="">Todos</option>
                <option value="ESTADO">ESTADO</option>
                <option value="SUPERVISION">SUPERVISIÓN</option>
                <option value="AUDITORIA MEDICA">AUDITORÍA MÉDICA</option>
                <option value="AUDITORIA MEDICA FINALIZADA">AUD. MÉD. FINALIZADA</option>
              </select>
            </th>
            <th>
              <input
                v-model="filtroObservacion"
                @input="aplicarPaginacion(1)"
                class="form-control form-control-sm"
                placeholder="Filtrar..."
              />
            </th>
            <th>
              <input
                v-model="filtroUsuario"
                @input="aplicarPaginacion(1)"
                class="form-control form-control-sm"
                placeholder="Filtrar..."
              />
            </th>
          </tr>
        </thead>
        <tbody>
          <tr
            v-for="b in datosPaginados"
            :key="b.idBitacoraTra"
            @dblclick="abrirModalEditar(b.idBitacoraTra)"
            title="Doble clic para ver el detalle"
          >
            <td class="text-center">
              <button
                type="button"
                class="btn btn-sm btn-outline-info"
                @click.stop="abrirModalEditar(b.idBitacoraTra)"
                title="Ver detalle"
              >
                <span class="material-icons" style="font-size:14px">search</span>
              </button>
            </td>
            <td class="text-nowrap">{{ getFormattedDate(b.fechaReg) }}</td>
            <td>
              <span class="badge" :class="badgeTipo(b.tipo)">{{ b.tipo }}</span>
            </td>
            <td>{{ b.observacion }}</td>
            <td>{{ b.usuarioNombre }}</td>
          </tr>
        </tbody>
        <tfoot>
          <tr class="table-secondary">
            <td colspan="5" class="text-end fw-bold small">
              Mostrando {{ datosPaginados.length }} de {{ bitacorasOrdenadas.length }} registros
            </td>
          </tr>
        </tfoot>
      </table>
    </div>

    <!-- Paginación -->
    <div
      class="d-flex justify-content-between align-items-center mt-2"
      v-if="bitacoratras.length > 0"
    >
      <span class="small text-muted">
        Página {{ paginaActual }} de {{ totalPaginas() }} — {{ bitacorasOrdenadas.length }} registros
      </span>
      <nav>
        <ul class="pagination pagination-sm mb-0">
          <li class="page-item" :class="{ disabled: paginaActual === 1 }">
            <a class="page-link" href="#" @click.prevent="aplicarPaginacion(1)">«</a>
          </li>
          <li class="page-item" :class="{ disabled: paginaActual === 1 }">
            <a class="page-link" href="#" @click.prevent="getPreviousPage">‹</a>
          </li>
          <li
            v-for="p in paginasVisibles"
            :key="p"
            class="page-item"
            :class="{ active: p === paginaActual, disabled: p === '...' }"
          >
            <a class="page-link" href="#"
               @click.prevent="p !== '...' && aplicarPaginacion(p)">{{ p }}</a>
          </li>
          <li class="page-item" :class="{ disabled: paginaActual === totalPaginas() }">
            <a class="page-link" href="#" @click.prevent="getNextPage">›</a>
          </li>
          <li class="page-item" :class="{ disabled: paginaActual === totalPaginas() }">
            <a class="page-link" href="#" @click.prevent="aplicarPaginacion(totalPaginas())">»</a>
          </li>
        </ul>
      </nav>
    </div>

    <!-- Modal detalle -->
    <div
      class="modal fade"
      id="ventanaModal"
      tabindex="-1"
      aria-hidden="true"
      v-if="modalWindow"
    >
      <div class="modal-dialog modal-lg">
        <div class="modal-content">
          <div class="modal-header bg-primary">
            <span class="material-icons text-white me-2">info</span>
            <h5 class="modal-title text-white">{{ titulo }}</h5>
            <button
              type="button"
              class="btn-close btn-close-white"
              data-bs-dismiss="modal"
              aria-label="Close"
            ></button>
          </div>
          <div class="modal-body">
            <div class="mb-3">
              <div class="row">
                <div class="col-2"><label class="form-label fw-bold">Número</label></div>
                <div class="col-10"><span>{{ datoBitacoraTra.idBitacoraTra }}</span></div>
              </div>
            </div>
            <div class="mb-3">
              <div class="row">
                <div class="col-2"><label class="form-label fw-bold">Fecha reg.</label></div>
                <div class="col-10"><span>{{ getFormattedDate(datoBitacoraTra.fechaReg) }}</span></div>
              </div>
            </div>
            <div class="mb-3">
              <div class="row">
                <div class="col-2"><label class="form-label fw-bold">Tipo</label></div>
                <div class="col-10">
                  <span class="badge" :class="badgeTipo(datoBitacoraTra.tipo)">
                    {{ datoBitacoraTra.tipo }}
                  </span>
                </div>
              </div>
            </div>
            <div class="mb-3">
              <div class="row">
                <div class="col-2"><label class="form-label fw-bold">Observación</label></div>
                <div class="col-10">
                  <span class="text-uppercase">{{ datoBitacoraTra.observacion }}</span>
                </div>
              </div>
            </div>
            <div class="mb-3">
              <div class="row">
                <div class="col-2"><label class="form-label fw-bold">Usuario</label></div>
                <div class="col-10"><span>{{ datoBitacoraTra.usuarioNombre }}</span></div>
              </div>
            </div>
          </div>
          <div class="modal-footer">
            <button type="button" class="btn btn-secondary btn-sm" data-bs-dismiss="modal">
              Cerrar
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import config     from "@/config";
import api        from "@/services/api";
import dateFormat from "@/modules/dateFormat.js";
import * as $     from "jquery";
window["$"]      = $;
window["jQuery"] = $;

export default {
  name: "BitacoraTramiteList",

  props: {
    p_idTramite: { type: Number, required: true },
  },

  data() {
    return {
      bitacoratras:        [],
      datoBitacoraTra:     {},
      descripcionBusqueda: "",
      tipoBusqueda:        "",
      titulo:              "",
      btnEditar:           false,
      modalWindow:         true,
      elementosPorPagina:  10,
      datosPaginados:      [],
      paginaActual:        1,
      // Ordenamiento
      campoOrden:          "fechaReg",
      ascendente:          false,
      // Filtros de columna
      filtroTipo:          "",
      filtroObservacion:   "",
      filtroUsuario:       "",
    };
  },

  computed: {
    bitacorasOrdenadas() {
      const campo = this.campoOrden;
      const lista = this.bitacoratras.filter(b => {
        const tipo = this.filtroTipo
          ? (b.tipo ?? "") === this.filtroTipo : true;
        const obs  = this.filtroObservacion
          ? String(b.observacion ?? "").toLowerCase()
              .includes(this.filtroObservacion.toLowerCase()) : true;
        const usr  = this.filtroUsuario
          ? String(b.usuarioNombre ?? "").toLowerCase()
              .includes(this.filtroUsuario.toLowerCase()) : true;
        return tipo && obs && usr;
      });
      return lista.sort((a, b) => {
        const va = a[campo] ?? "";
        const vb = b[campo] ?? "";
        if (campo === "fechaReg") {
          const da = new Date(va), db = new Date(vb);
          if (!isNaN(da) && !isNaN(db))
            return this.ascendente ? da - db : db - da;
        }
        const cmp = String(va).localeCompare(String(vb), "es");
        return this.ascendente ? cmp : -cmp;
      });
    },

    paginasVisibles() {
      const total = this.totalPaginas();
      const actual = this.paginaActual;
      const delta = 2;
      const rango = [];
      for (let i = Math.max(2, actual - delta); i <= Math.min(total - 1, actual + delta); i++) {
        rango.push(i);
      }
      if (rango.length && rango[0] > 2)                        rango.unshift("...");
      if (rango.length && rango[rango.length - 1] < total - 1) rango.push("...");
      const paginas = [1];
      rango.forEach(p => paginas.push(p));
      if (total > 1) paginas.push(total);
      return paginas;
    },
  },

  mounted() {
    this.getDataPaginaTodos();
  },

  methods: {
    // ── Formato fecha ──────────────────────────────────────
    getFormattedDate(date) {
      return dateFormat.getFormattedDateTime(date);
    },

    // ── Ordenamiento ──────────────────────────────────────
    ordenarPor(campo) {
      this.ascendente = this.campoOrden === campo ? !this.ascendente : true;
      this.campoOrden = campo;
      this.aplicarPaginacion(1);
    },
    iconOrden(campo) {
      if (this.campoOrden !== campo) return "⇅";
      return this.ascendente ? "↑" : "↓";
    },

    // ── Badge por tipo ────────────────────────────────────
    badgeTipo(tipo) {
      return {
        "bg-secondary":         tipo === "ESTADO",
        "bg-primary":           tipo === "SUPERVISION",
        "bg-warning text-dark": tipo === "AUDITORIA MEDICA",
        "bg-success":           tipo === "AUDITORIA MEDICA FINALIZADA",
      };
    },

    // ── Paginación ────────────────────────────────────────
    totalPaginas() {
      return Math.max(1, Math.ceil(this.bitacorasOrdenadas.length / this.elementosPorPagina));
    },
    aplicarPaginacion(noPagina) {
      this.paginaActual   = noPagina;
      const ini           = (noPagina - 1) * this.elementosPorPagina;
      this.datosPaginados = this.bitacorasOrdenadas.slice(ini, ini + this.elementosPorPagina);
    },
    getPreviousPage() {
      if (this.paginaActual > 1) this.aplicarPaginacion(this.paginaActual - 1);
    },
    getNextPage() {
      if (this.paginaActual < this.totalPaginas()) this.aplicarPaginacion(this.paginaActual + 1);
    },

    // ── Carga de datos ────────────────────────────────────
    getDataPaginaTodos() {
      this.descripcionBusqueda = "";
      this.tipoBusqueda        = "";
      this.filtroTipo          = "";
      this.filtroObservacion   = "";
      this.filtroUsuario       = "";
      api.get(`/vwbitacoratras/idtramite/${this.p_idTramite}`)
        .then(r => {
          this.bitacoratras = Array.isArray(r.data) ? r.data : [];
          this.aplicarPaginacion(1);
        });
    },

    getDataNombre() {
      if (!this.descripcionBusqueda.trim()) return;
      this.tipoBusqueda = "";
      api.get(`/vwbitacoratras/observacion/${this.p_idTramite}/${this.descripcionBusqueda}`)
        .then(r => {
          this.bitacoratras = Array.isArray(r.data) ? r.data : [];
          this.aplicarPaginacion(1);
        });
    },

    getDataEstado() {
      if (!this.tipoBusqueda) return;
      this.descripcionBusqueda = "";
      api.get(`/vwbitacoratras/tipo/${this.p_idTramite}/${this.tipoBusqueda}`)
        .then(r => {
          this.bitacoratras = Array.isArray(r.data) ? r.data : [];
          this.aplicarPaginacion(1);
        });
    },

    // ── Modal ─────────────────────────────────────────────
    async abrirModalEditar(idBitacoraTra) {
      this.modalWindow = true;
      this.titulo      = "Detalle Bitácora";
      this.btnEditar   = true;
      try {
        const resp           = await api.get("/vwbitacoratras/" + idBitacoraTra);
        this.datoBitacoraTra = resp.data;
      } catch (e) {
        console.error("Error al cargar bitácora:", e);
        return;
      }
      this.$nextTick(() => $("#ventanaModal").modal("show"));
    },

    // ── PDF ───────────────────────────────────────────────
    bitacoraTramitePDF() {
      window.open(`${config.apiBaseUrl}/reportes/pdf/12/${this.p_idTramite}`, "_blank");
    },
  },
};
</script>

<style scoped>
.th-sort {
  cursor: pointer;
  user-select: none;
  white-space: nowrap;
}
.th-sort:hover {
  background-color: #3d5166;
}
.table-hover tbody tr {
  cursor: pointer;
}
thead tr:nth-child(2) th {
  font-weight: normal;
  padding: 4px 6px;
}
</style>